import {Injectable, OnInit} from '@angular/core';
import {PermissionsModel} from '../Models/PermissionsModel';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  private mapPermissions = new Map();
  private permissions = {} as PermissionsModel;

  constructor(private storage: StorageService) {
  }

  LoadPermissions(permsJsonObj: any, sender = '') {

    const f1 = JSON.stringify(permsJsonObj);
    const x1 = JSON.parse(f1);
    // const x1 = JSON.parse(JSON.stringify(aPermsJsonString)));
    for (const key in x1) {
      if (Object.prototype.hasOwnProperty.call(x1, key)) {
        this.mapPermissions.set(key, x1[key]);
        this.permissions[key] = x1[key];
      }
    }
  }

  Get(aName: string): boolean {
    if (this.mapPermissions.size === 0) {
      const x1 = JSON.parse(this.storage.StorageGet('Permissions', ''));
      for (const key in x1) {
        if (Object.prototype.hasOwnProperty.call(x1, key)) {
          this.mapPermissions.set(key, x1[key]);
        }
      }
    }
    return this.mapPermissions.get(aName);
  }

  ListPermissions() {
    // console.log('---Permissions---');
    this.mapPermissions.forEach((value: string, key: string) => {
      // console.log(key + ' => ' + value);
    });
  }

  ClearPermissions() {
    this.mapPermissions.clear();
  }

  getTruePermissionsObject(): PermissionsModel {

    this.permissions = JSON.parse(this.storage.StorageGet('Permissions', ''));

    const perms = Object.keys(this.permissions)
      .filter(key => this.permissions[key] === true)
      .reduce((acc, key) => {
        const permissionValue = this.permissions[key];
        acc[key] = permissionValue;
        return acc;
      }, {} as PermissionsModel);

    // console.log('---True ONLY Permissions---');
    // console.log(lee);

    return perms;
  }

  getTruePermissionsMap(): Map<any, any> {

    this.permissions = JSON.parse(this.storage.StorageGet('Permissions', ''));

    for (const [key, value] of Object.entries(this.permissions)) {
      if (value) {
        this.mapPermissions.set(key, value);
      }
    }

    // console.log('---True MAP Permissions---');
    // console.log(this.mapPermissions);

    return this.mapPermissions;
  }
}
